import { useEffect, useState } from "react";
import { ProductsService } from "../../../services/products.service";
import { ProductsDataType } from "../../../interfaces/admin.interface";
import { Input, message, Modal, Spin } from "antd";
import { CampaignsService } from "../../../services/campaings.service";
import MainButton from "../../../components/shared/MainButton/MainButton";
import styles from "./AddProductModal.module.scss";
interface AddProductModalProps {
  title: string;
  campaignId: number;
  productIds: number[];
  addProductModal: boolean;
  setAddProductModal: (value: boolean) => void;
  onUpdateCampaignProducts: (
    campaignId: number,
    newProducts: { product_id: number }[]
  ) => void;
}
const AddProductModal: React.FC<AddProductModalProps> = ({
  title,
  campaignId,
  productIds,
  addProductModal,
  setAddProductModal,
  onUpdateCampaignProducts,
}) => {
  const [products, setProducts] = useState<ProductsDataType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [searchValue, setSearchValue] = useState<string>("");

  const [selectedProductIds, setSelectedProductIds] = useState<
    { product_id: number }[]
  >([]);

  const totalPages = Math.ceil(totalCount / pageSize);
  useEffect(() => {
    if (addProductModal) {
      setLoading(true);
      ProductsService.getAllProducts(currentPage, pageSize)
        .then((response) => {
          if (Array.isArray(response?.data?.data)) {
            setProducts(response?.data?.data);
            setTotalCount(response?.data?.count);

            const selectedIds = response?.data?.data
              .filter((product: ProductsDataType) =>
                productIds.includes(product.id)
              )
              .map((product: ProductsDataType) => ({ product_id: product.id }));
            setSelectedProductIds(selectedIds);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [currentPage, pageSize, productIds, addProductModal]);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const handlePageSizeChange = (size: number) => {
    setPageSize(size);
    setCurrentPage(1);
  };
  const handleAddToCampaign = async () => {
    if (selectedProductIds.length > 0) {
      const payload = { products: selectedProductIds };
      const response = await CampaignsService.addProductToCamaigns(
        campaignId,
        payload
      );
      if (response.status === 200) {
        message.success(`Məhsullar ${title} kampaniyasına əlavə edildi`);
        const addedProducts = response?.data?.data?.products.map(
          (product: any) => ({ product_id: product.product_id })
        );
        onUpdateCampaignProducts(campaignId, addedProducts);
        setAddProductModal(false);
        setSelectedProductIds(addedProducts);
      } else {
        message.info("Əlavə ediləcək məhsul yoxdur.");
      }
    }
  };

  const toggleCheckbox = (productId: number) => {
    setSelectedProductIds((prevSelectedIds) => {
      const isSelected = prevSelectedIds.some(
        (item) => item.product_id === productId
      );
      if (isSelected) {
        return prevSelectedIds.filter((item) => item.product_id !== productId);
      } else {
        return [...prevSelectedIds, { product_id: productId }];
      }
    });
  };
  useEffect(() => {
    if (!addProductModal) {
      setSelectedProductIds([]);
    }
  }, [addProductModal]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchValue(value);
    setCurrentPage(1);

    if (value.trim() === "") {
      ProductsService.getAllProducts(1, pageSize).then((response) => {
        if (Array.isArray(response?.data?.data)) {
          setProducts(response?.data?.data);
          setTotalCount(response?.data?.count);

          const selectedIds = response?.data?.data
            .filter((product: ProductsDataType) =>
              productIds.includes(product.id)
            )
            .map((product: ProductsDataType) => ({ product_id: product.id }));
          setSelectedProductIds(selectedIds);
        }
      });
    } else {
      ProductsService.getSearchData(value).then((response) => {
        if (Array.isArray(response?.data?.products?.data)) {
          const searchedData = response.data.products.data;
          setProducts(searchedData);
          setTotalCount(searchedData.length);
        }
      });
    }
  };

  useEffect(() => {
    if (addProductModal && searchValue.trim() === "") {
      setLoading(true);
      ProductsService.getAllProducts(currentPage, pageSize)
        .then((response) => {
          if (Array.isArray(response?.data?.data)) {
            setProducts(response?.data?.data);
            setTotalCount(response?.data?.count);

            const selectedIds = response?.data?.data
              .filter((product: ProductsDataType) =>
                productIds.includes(product.id)
              )
              .map((product: ProductsDataType) => ({ product_id: product.id }));
            setSelectedProductIds(selectedIds);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [currentPage, pageSize, productIds, addProductModal, searchValue]);

  return (
    <Modal
      title={`${title} kampaniyasına məhsulları əlavə edin`}
      open={addProductModal}
      onCancel={() => setAddProductModal(false)}
      footer={null}
      width={"100%"}
      style={{ minWidth: "340px" }}
      centered
    >
      <div className={styles.add_product}>
        <div className={styles.paginations}>
          <div className={styles.search}>
            <Input
              placeholder="Məhsulu axtarın..."
              value={searchValue}
              onChange={handleSearch}
            />
          </div>
          <div>
            <div className={styles.pagination_controls}>
              <div>
                <button
                  onClick={() => setCurrentPage(1)}
                  disabled={currentPage === 1}
                >
                  Əvvəl
                </button>
                <button
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}
                >
                  Geri
                </button>
              </div>
              <span>
                Səhifə {currentPage} / {totalPages}
              </span>
              <div>
                <button
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                >
                  İrəli
                </button>
                <button
                  onClick={() => setCurrentPage(totalPages)}
                  disabled={currentPage === totalPages}
                >
                  Son
                </button>
              </div>
            </div>
            <div className={styles.page_size_controls}>
              <label>Hər səhifədə məhsul sayı:</label>
              <select
                value={pageSize}
                onChange={(e) => handlePageSizeChange(Number(e.target.value))}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
          </div>
        </div>
        <h1 className={styles.title}>Məhsullar</h1>
        <form action="">
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "30px 0",
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <>
              <div className={styles.product_checkbox_wrapper}>
                {products.map((product, index) => (
                  <div
                    className={styles.product_card}
                    key={index}
                    onClick={() => toggleCheckbox(product.id)}
                  >
                    {/* {index + 1} */}
                    <div className={styles.product_checkbox}>
                      <input
                        type="checkbox"
                        name={product.name}
                        id={product.name}
                        checked={selectedProductIds.some(
                          (item) => item.product_id === product.id
                        )}
                        readOnly
                      />
                      <h3>{product.name}</h3>
                    </div>
                    <div className={styles.product}>
                      {product.cover_image ? (
                        <div className={styles.product_img}>
                          <img src={product.cover_image} alt="" />
                        </div>
                      ) : null}
                      <p>{product.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className={styles.add_product_btn}>
                <MainButton onClick={handleAddToCampaign}>
                  Əlavə edin
                </MainButton>
              </div>
            </>
          )}
        </form>
      </div>
    </Modal>
  );
};

export default AddProductModal;
